import { isFinite, find } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"
import { compareId } from "helpers/securities"

export function computeCellContent(content, displayZeros, percent = true) {
  let cellContent = displayZeros ? content : "-"

  if (content || (displayZeros && isFinite(content))) {
    cellContent = percent ? numberFormatter(content * 100) : numberFormatter(content)
  }

  return cellContent
}

export function findEquitySize(security, positions) {
  for (const positionType in positions) {
    if (positions[positionType] && positions[positionType].length > 0) {
      let positionData

      switch (positionType) {
        case "equities":
          positionData = find(positions[positionType], ({ id }) => compareId(security.id, id))
          break
        case "fixedIncomes":
          positionData = find(positions[positionType], ({ id: { isin } }) =>
            isin === security.id.isin,
          )
          break
        default:
          positionData = find(positions[positionType], ({ id }) =>
            id === security.id,
          )
          break
      }

      if (positionData) {
        return positionData.economicExposure
      }
    }
  }
}
